import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';

import { ActionComponent } from './components/action/action.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { ButtonComponent } from './components/button/button.component';
import { DelayButtonComponent } from './components/delay-button/delay-button.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { MoreButtonComponent } from './components/more-button/more-button.component';
import { NextButtonComponent } from './components/next-button/next-button.component';
import { PrevButtonComponent } from './components/prev-button/prev-button.component';
import { ToggleButtonComponent } from './components/toggle-button/toggle-button.component';
import { ToolbarButtonComponent } from './components/toolbar-button/toolbar-button.component';

@NgModule({
  imports: [
    ActionComponent,
    ButtonComponent,
    BackButtonComponent,
    DelayButtonComponent,
    IconButtonComponent,
    MoreButtonComponent,
    NextButtonComponent,
    PrevButtonComponent,
    ToolbarButtonComponent,
    ToggleButtonComponent,
  ],
  exports: [
    ActionComponent,
    ButtonComponent,
    BackButtonComponent,
    DelayButtonComponent,
    IconButtonComponent,
    MoreButtonComponent,
    NextButtonComponent,
    PrevButtonComponent,
    ToolbarButtonComponent,
    MatButtonModule,
    ToggleButtonComponent,
  ],
})
export class SharedButtonsModule {}
